import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { request } from '../../interfaces/networkManager';
import { useEffect } from 'react';
import TableLine from './part/TabLine';
import { getCurrentEnv } from '../../services/ApiServices';
import { Process } from '../../models/process';
import Error from '../../components/Error/Error';

export default function OrdersScreen() {
	const [process, setProcess] = useState<Process[] | null>([]);
	const [error, setError] = useState<string | null>(null);
	const env = getCurrentEnv();

	useEffect(() => {
		const requestOptions = {
			headers: {
				Authorization: `JWT ${localStorage.getItem('token')}`,
			},
			method: 'GET',
		};

		request<Process[]>('/processes/', requestOptions)
			.then((_p: Process[]) => {
				if (!_p.length)
					return setError('Erreur lors de la récupération des process');
				setProcess(_p);
			})
			.catch((error) => setError('Erreur lors de la récupération des commandes'));
	}, []);

	return (
		<Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
			<Grid container spacing={1}>
				<Grid size={12}>
					<Grid container spacing={3}>
						<Grid size={12}>
							<Paper
								sx={{
									p: 2,
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<Typography component="h2" variant="h4" color={env === 'prod' ? 'error' : 'primary'} gutterBottom sx={{ mb: 2 }}>
									Commandes
								</Typography>
								{process?.map((row: Process, index: number) => (
									<TableLine key={index} row={row} env={env} />
								))}
								{error ? (<Grid size={12}><Error message={error} /></Grid>) : null}
							</Paper>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
}
